<script lang="ts" setup>
import { Routes, RoutesName } from '@/enums/Routes'
import { useCommonElementsStore } from '@/store/commonElements.store'
import TechnologyPanel from '@/components/panels/TechnologyPanel.vue'
import { usePortfolioStore } from '@/store/portfolio.store'
import ContactComponent from '@/components/ContactComponent.vue'
import SoftwareSolutionSection from '@/components/home/SoftwareSolutionSection.vue'
import Portfolio from '@/components/portfolio/Portfolio.vue'
import { ApplicationMode } from '@/enums/ApplicationMode'
import PartnerFeedback from '@/components/portfolio/PartnerFeedback.vue'
import OurRecomendations from '@/components/portfolio/OurRecomendations.vue'

const commonStore = useCommonElementsStore()
const portfolio = usePortfolioStore()
const sideChanger = portfolio.getSideChanger

useHead({ title: RoutesName.PORTFOLIO })

const prev = {
  title: sideChanger?.leftText ?? '',
  section: RoutesName.SERVICES,
  route: Routes.SERVICES,
}
const next = {
  title: sideChanger?.rightText ?? '',
  section: RoutesName.CONTACT,
  route: Routes.CONTACT,
}
const header = portfolio.getHeader
const contact = portfolio.getContact
const digital = portfolio.getDigitalPartners
</script>

<template>
  <div>
    <HeaderComponent
      v-if="header"
      :title="header.title"
      :describe="header.copy"
      :background="header.background"
      :mode="ApplicationMode.Short"
    />
    <PartnerFeedback
      v-if="portfolio.getPartnerFeedback && commonStore.getBestRecomendation"
      :feedback="portfolio.getPartnerFeedback"
      :star-rating-card="commonStore.getBestRecomendation"
    />
    <Portfolio
      id="portfolio"
      v-if="commonStore.getcaseAndPortfolio"
      :case-study="commonStore.getcaseAndPortfolio"
    />
    <SoftwareSolutionSection v-if="digital" :software="digital" />
    <TechnologyPanel
      v-if="commonStore.getTechnologies && portfolio.getTechnologySection"
      :technologies-section="portfolio.getTechnologySection"
      :technologies="commonStore.getTechnologies"
    />
    <OurRecomendations
      v-if="portfolio.getRecomendation && commonStore.getRecomendation"
      :recomendation="portfolio.getRecomendation"
      :star-rating-card="commonStore.getRecomendation"
    />
    <ApplicationContainer>
      <ElCard class="rounded--1">
        <ContactComponent
          v-if="contact"
          :title="contact.title"
          :copy="contact.copy"
        />
      </ElCard>
    </ApplicationContainer>
    <SideChanger v-if="sideChanger" :prev="prev" :next="next">
      <PersonDescribeSection
        :business-card="commonStore.getBusinessCard"
        v-if="commonStore.getBusinessCard"
      />
    </SideChanger>
  </div>
</template>

<style scoped>
:deep(.short) {
  @media screen and (max-width: 750px) {
    height: 400px !important;
  }
}

:deep(.app__container__short-img) {
  min-height: 750px;

  @media screen and (min-width: 429px) {
    min-height: 650px;
  }

  @media screen and (min-width: 1024px) {
    min-height: 600px;
  }
}
</style>
